
//This component is used to display each user in the user search list
const UserListItem = ({ handleFunction, user }) => {

    return (
        <div onClick={handleFunction} className='modal_listItem'>
            <span className='span_avatar'>
                <img className='imgAvatar' alt='Avatar' src={user.pic} />
            </span>
            <div className='modal_listItem-data'>
                <p><b>Name: </b> {user.name} </p>
                <p><b>Email: </b> {user.email.split('@')[0] + '@...'} </p>
            </div>
        </div>
    );
};

export default UserListItem;
